module.exports = __webpack_public_path__ + "static/media/lima2.d0a522c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/lima2.jpg
// module id = 111
// module chunks = 0